// extracted by mini-css-extract-plugin
export var editButton = "_kq-0";